










































































































import Component, { mixins } from 'vue-class-component';
import BaseFormMixin from '@/mixins/base-form-mixin';
import DictServices, { DictDto, DictItemDto } from '@/services/dict';
import { Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { checkCode, sleep } from '@/libs/util';
@Component
export default class DictForm extends mixins(BaseFormMixin) {
  dictSrv = new DictServices();
  formData: DictDto = {};
  id: any = 0;
  categoryId: any = 0;
  keepalive: boolean = true;
  breadList = [{ name: '创建字典' }];

  created() {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;

    this.getBaseData();
  }

  activated() {
    this.onIdChange();
  }

  parentDictList = [];
  async getBaseData() {
    // 上级字典
    this.parentDictList = await this.dictSrv.getList();
  }

  filterParentDictList(input: string, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.cache = this.isNeedCache(from, to);
    this.onIdChange();
  }

  refreshKeepalive() {
    if (!this.$route.query.keepalive) {
      this.keepalive = false;
      this.$router.push({
        query: { ...this.$route.query, keepalive: 'true' }
      });
    } else {
      this.keepalive = true;
    }
  }

  @Watch('id')
  async onIdChange() {
    let path = this.$route.path;

    if (path === '/decision/dict/add') {
      this.refreshKeepalive();
      if (this.keepalive && this.cache) return false;

      this.formData = {};
      this.dictItemList = [];
      this.current = 0;

      let categories = await this.dictSrv.getCategory();
      let category = categories.filter((category: any) => category.id == this.categoryId)[0];
      this.breadList = [{ name: category.label }, { name: '创建字典' }];
    } else if (path === '/decision/dict/edit') {
      if ((!this.id || this.id == this.formData.id) && this.cache) return false;
      this.spinning = true;
      let { dictDef, dictItemDefList } = await this.dictSrv.getInfo(this.id);
      this.spinning = false;
      this.formData = dictDef;
      this.dictItemList = dictItemDefList;
      this.current = 0;
      this.changeParentDictCode(this.formData.parentDictCode || '');

      this.breadList = [{ name: dictDef.dictCategoryName }, { name: dictDef.dictName }, { name: '编辑字典' }];
    }
  }

  DICT_ITEM: any[] = [];
  async changeParentDictCode(e: string) {
    if (!this.SYS_DICT[e]) {
      await sleep(100);
      this.changeParentDictCode(e);
      return false;
    }
    this.DICT_ITEM = [];
    if (e) {
      this.DICT_ITEM = this.SYS_DICT[e];
    }
  }

  dictItemList: DictItemDto[] = [];
  addList() {
    this.dictItemList.push({
      dictItemSort: 1
    });
  }
  removeList(index: number) {
    this.dictItemList.splice(index, 1);
  }

  async next() {
    if (this.current === 0) {
      const must: { field: 'dictCode' | 'dictName' | 'dictKind'; msessage: string }[] = [
        { field: 'dictCode', msessage: '字典编码不能为空' },
        { field: 'dictName', msessage: '字典名称不能为空' },
        { field: 'dictKind', msessage: '字典分类不能为空' }
      ];
      for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.msessage);
          return false;
        }
      }
      if (!checkCode(this.formData.dictCode)) {
        this.$message.error('编码只能包含英文字母、数字、下划线');
        return false;
      }
      if (!this.id) {
        let code = 'DICT_' + this.formData.dictCode;
        let exist = await this.dictSrv.getList({ dictCode_eq: code });
        if (exist.length > 0) {
          this.$message.error(`编码[${code}]已经存在`);
          return false;
        }
      }
    }
    this.current++;
  }

  checkDictItemList() {
    let result = true;
    let code: string = this.formData.dictCode || '';
    if (!/$DICT_/.test(code)) {
      code = 'DICT_' + code;
    }
    this.dictItemList = this.dictItemList.map((v: any, index: number) => {
      if (!v.dictItemValue || !v.dictItemName) result = false;
      return {
        ...v,
        dictItemCode: code + '_' + (v.dictItemValue || ''),
        dictItemSort: index + 1
      };
    });

    return result;
  }

  loading: boolean = false;
  async confirm() {
    let result = this.checkDictItemList();
    if (!result) {
      this.$message.error('请将条目信息填写完整');
      return false;
    }
    this.formData.dictItemDefList = this.dictItemList;
    this.loading = true;
    if (this.id) {
      let res = await this.dictSrv.update(this.formData);
      if (res) {
        this.replaceUrlWithOutConfirm('/decision/dict/detail?id=' + this.id);
        this.formData = {};
        this.dictItemList = [];
        this.current = 0;
      }
    } else {
      let categoryId: number | boolean = typeof this.$route.query.categoryId === 'string' ? parseInt(this.$route.query.categoryId) : false;
      if (!categoryId) {
        this.$message.error('参数错误：没有指定目录');
        return false;
      }
      this.formData.dictCategoryId = categoryId;
      let res = await this.dictSrv.add(this.formData);
      if (res) {
        this.replaceUrlWithOutConfirm('/decision/dict/detail?id=' + res.id);
        this.formData = {};
        this.dictItemList = [];
        this.current = 0;
      }
    }
    this.loading = false;
    this.HANDLE_RELOAD_DICK_MENU();
  }

  @Mutation HANDLE_RELOAD_DICK_MENU: any;
}
